import lozad from "lozad";
import Swiper, { Navigation, Pagination } from "swiper";
import { header } from "../index/scripts/header";
$(document).ready(function () {
	header.init();
	clickApplyJob();
	watchObserveInputFile();
});
function watchObserveInputFile() {
	$('input[name="file-cv"]').on("change", function () {
		const file = this.files[0];
		if (file) {
			const fileName = file.name;
			// Create/update filename display
			const fileNameDisplay = $("<span>", {
				class: "file-name text-sm text-body-text-66 mt-1 block",
				text: "File CV: " + fileName,
			});

			// Remove existing filename display if any
			$(this).closest(".form-input-file").find(".file-name").remove();
			// Add new filename display
			$(this).closest(".form-input-file").append(fileNameDisplay);
		}
	});
}

function clickApplyJob() {
	$(".btn-request-advise").on("click", function (e) {
		const nameProject = $(this).closest(".item-pricing").find(".pricing-title").text();
		const cateProject = $(".wrap-tab-list li.active a").text();
		Fancybox.show([{ src: "#modal-contact", type: "inline" }]);
		$('input[name="loai-du-an"]').val(nameProject + " - " + cateProject);
	});
}
/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();